export const PUBLIC_PROJECT_TEMPLATE_CATEGORY_ALL = 'all'
